import React from 'react';
import UserAvatar from '@components/UserAvatar';
import { ReactComponent as CloseSvg } from '@assets/icons/cross.svg';
import { MemberUserDto } from '@api/Api';

import './PotentialManager.less';

type PotentialManagerProps = {
  userData: MemberUserDto;
};

export default function PotentialManager({ userData }: PotentialManagerProps) {
  return (
    <div className="potential-manager">
      <div className="potential-manager--user">
        <UserAvatar
          isActive
          size="large"
          src={userData.picture.url || ''}
          userEmail={userData.email || ''}
          userName={userData.name || ''}
        />
        <div className="potential-manager--name">
          <span>{userData?.name}</span>
          <span>{userData?.email}</span>
        </div>
      </div>
      <CloseSvg className="close-icon" />
    </div>
  );
}
